<template>
  <div
    v-if="variants.HEADER_1 === variant"
    class="navigation-header-one position-unset tw-absolute tw-left-0 tw-top-0 tw-z-50 tw-flex tw-w-full tw-flex-col"
    :class="{
      'scrolled !tw-fixed': isScrolled,
      '!tw-bg-[var(--c-primary)] !tw-shadow-none xl:!tw-bg-white xl:!tw-shadow': menuVisible && isScrolled,
    }"
    :style="`
      z-index: 9999;
      ${
        isScrolled || vars.fixedColorBool
          ? `background-color: var(--c-nav-secondary); color: var(--c-text-primary);`
          : 'background-color: transparent;'
      }
      
      color: ${vars.textColor ? `var(--c-${vars.textColor});` : 'var(--c-text-secondary);'}
    `"
  >
    <div
      class="tw-relative tw-hidden tw-w-full tw-items-center tw-justify-end tw-gap-5 tw-px-8 tw-pt-2 tw-duration-300 xl:tw-flex"
      :class="
        menuVisible && isScrolled ? '!tw-bg-[var(--c-primary)] !tw-shadow-none xl:!tw-bg-white xl:!tw-shadow' : ''
      "
      :style="`
      ${
        isScrolled || vars.fixedColorBool
          ? `background-color: var(--c-nav); color: var(--c-text-primary);`
          : 'background-color: transparent;'
      }
      color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary) '};
    `"
    >
      <div class="tw-flex tw-gap-4">
        <nuxt-link
          v-for="branch in branches"
          :to="`tel:${branch.phone_number}`"
          class="n-link tw-text-white"
          :style="`${isScrolled || vars.fixedColorBool ? 'color: var(--c-text-primary)' : ''}`"
        >
          <span class="">{{ branch.name }}: {{ branch.phone_number }}</span>
        </nuxt-link>
      </div>
      <div class="tw-flex tw-items-center tw-justify-start tw-gap-3">
        <nuxt-link
          v-if="vars.facebookUrl"
          :to="vars.facebookUrl"
          target="_blank"
          class="n-link tw-group tw-flex tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
        >
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="9.15517"
              cy="9.15517"
              r="8.90517"
              :stroke="`${isScrolled || vars.fixedColorBool ? '#333333' : 'white'}`"
              stroke-width="0.5"
            />
            <g clip-path="url(#clip0_14_79)">
              <path
                d="M9.83255 9.6631H10.6802L11.0193 8.30678H9.83255V7.62861C9.83255 7.27936 9.83255 6.95045 10.5107 6.95045H11.0193V5.81114C10.9088 5.79656 10.4914 5.76367 10.0506 5.76367C9.12997 5.76367 8.47623 6.32553 8.47623 7.35735V8.30678H7.45898V9.6631H8.47623V12.5453H9.83255V9.6631Z"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                :class="`${isScrolled || vars.fixedColorBool ? 'tw-fill-[#333333]' : 'tw-fill-white'}`"
              />
            </g>
            <defs>
              <clipPath id="clip0_14_79">
                <rect width="8.13793" height="8.13793" fill="white" transform="translate(5.08594 5.08594)" />
              </clipPath>
            </defs>
          </svg>
        </nuxt-link>

        <nuxt-link
          v-if="vars.instagramUrl"
          :to="vars.instagramUrl"
          target="_blank"
          class="n-link tw-group tw-flex tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          style="border-color: white"
        >
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="9.46572"
              cy="9.15517"
              r="8.90517"
              :stroke="`${isScrolled || vars.fixedColorBool ? '#333333' : 'white'}`"
              stroke-width="0.5"
            />
            <g clip-path="url(#clip0_14_83)">
              <path
                d="M8.04089 5.76367H10.8892C11.9742 5.76367 12.8558 6.64528 12.8558 7.73034V10.5786C12.8558 11.1002 12.6486 11.6004 12.2798 11.9693C11.911 12.3381 11.4108 12.5453 10.8892 12.5453H8.04089C6.95583 12.5453 6.07422 11.6637 6.07422 10.5786V7.73034C6.07422 7.20875 6.28142 6.70852 6.65024 6.3397C7.01906 5.97087 7.51929 5.76367 8.04089 5.76367ZM7.97307 6.44183C7.64932 6.44183 7.33884 6.57044 7.10991 6.79936C6.88099 7.02829 6.75238 7.33878 6.75238 7.66252V10.6464C6.75238 11.3212 7.2983 11.8671 7.97307 11.8671H10.957C11.2807 11.8671 11.5912 11.7385 11.8201 11.5096C12.0491 11.2807 12.1777 10.9702 12.1777 10.6464V7.66252C12.1777 6.98775 11.6317 6.44183 10.957 6.44183H7.97307ZM11.2452 6.95045C11.3576 6.95045 11.4654 6.99511 11.5449 7.0746C11.6244 7.15408 11.669 7.26189 11.669 7.3743C11.669 7.48672 11.6244 7.59452 11.5449 7.67401C11.4654 7.7535 11.3576 7.79815 11.2452 7.79815C11.1328 7.79815 11.025 7.7535 10.9455 7.67401C10.866 7.59452 10.8213 7.48672 10.8213 7.3743C10.8213 7.26189 10.866 7.15408 10.9455 7.0746C11.025 6.99511 11.1328 6.95045 11.2452 6.95045ZM9.46502 7.45907C9.91467 7.45907 10.3459 7.6377 10.6639 7.95565C10.9818 8.2736 11.1604 8.70483 11.1604 9.15448C11.1604 9.60412 10.9818 10.0354 10.6639 10.3533C10.3459 10.6713 9.91467 10.8499 9.46502 10.8499C9.01537 10.8499 8.58414 10.6713 8.26619 10.3533C7.94824 10.0354 7.76962 9.60412 7.76962 9.15448C7.76962 8.70483 7.94824 8.2736 8.26619 7.95565C8.58414 7.6377 9.01537 7.45907 9.46502 7.45907ZM9.46502 8.13723C9.19523 8.13723 8.93649 8.24441 8.74572 8.43518C8.55496 8.62595 8.44778 8.88469 8.44778 9.15448C8.44778 9.42427 8.55496 9.683 8.74572 9.87377C8.93649 10.0645 9.19523 10.1717 9.46502 10.1717C9.73481 10.1717 9.99355 10.0645 10.1843 9.87377C10.3751 9.683 10.4823 9.42427 10.4823 9.15448C10.4823 8.88469 10.3751 8.62595 10.1843 8.43518C9.99355 8.24441 9.73481 8.13723 9.46502 8.13723Z"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                :class="`${isScrolled || vars.fixedColorBool ? 'tw-fill-[#333333]' : 'tw-fill-white'}`"
              />
            </g>
            <defs>
              <clipPath id="clip0_14_83">
                <rect width="8.13793" height="8.13793" fill="white" transform="translate(5.39648 5.08594)" />
              </clipPath>
            </defs>
          </svg>
        </nuxt-link>
        <nuxt-link
          v-if="vars.youtubeUrl"
          :to="vars.youtubeUrl"
          target="_blank"
          class="n-link tw-group tw-flex tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          style="border-color: white"
        >
          <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="10.0868"
              cy="9.15517"
              r="8.90517"
              :stroke="`${isScrolled || vars.fixedColorBool ? '#333333' : 'white'}`"
              stroke-width="0.5"
            />
            <g clip-path="url(#clip0_14_91)">
              <path
                d="M10.0861 6.44238C10.376 6.44238 10.6734 6.44984 10.9616 6.46205L11.3021 6.47833L11.6279 6.49765L11.9331 6.51834L12.2118 6.54004C12.5143 6.56319 12.7989 6.69227 13.0156 6.90456C13.2323 7.11686 13.3672 7.39877 13.3966 7.70071L13.4101 7.84482L13.4356 8.15338C13.4593 8.47314 13.4769 8.82171 13.4769 9.15503C13.4769 9.48834 13.4593 9.83692 13.4356 10.1567L13.4101 10.4652C13.4057 10.5147 13.4013 10.5625 13.3966 10.6093C13.3672 10.9113 13.2323 11.1933 13.0155 11.4056C12.7987 11.6179 12.514 11.7469 12.2115 11.77L11.9334 11.7914L11.6283 11.8124L11.3021 11.8317L10.9616 11.848C10.67 11.8607 10.3781 11.8672 10.0861 11.8677C9.79418 11.8672 9.50228 11.8607 9.21061 11.848L8.87017 11.8317L8.54432 11.8124L8.23915 11.7914L7.96042 11.77C7.65794 11.7469 7.37332 11.6178 7.15662 11.4055C6.93992 11.1932 6.80503 10.9113 6.77567 10.6093L6.76211 10.4652L6.73668 10.1567C6.71075 9.8234 6.69696 9.4893 6.69531 9.15503C6.69531 8.82171 6.71294 8.47314 6.73668 8.15338L6.76211 7.84482C6.76652 7.79531 6.77093 7.7475 6.77567 7.70071C6.80502 7.39883 6.93986 7.11695 7.15649 6.90467C7.37312 6.69238 7.65767 6.56327 7.96008 6.54004L8.23847 6.51834L8.54364 6.49765L8.86984 6.47833L9.21027 6.46205C9.50205 6.44938 9.79406 6.44282 10.0861 6.44238ZM10.0861 7.12054C9.80638 7.12054 9.5185 7.128 9.23842 7.13953L8.9068 7.15547L8.5884 7.17412L8.28933 7.19446L8.01535 7.21583C7.87136 7.22604 7.73563 7.28691 7.63222 7.38765C7.52882 7.48838 7.46442 7.62247 7.45044 7.76615C7.41077 8.1761 7.37347 8.68642 7.37347 9.15503C7.37347 9.62364 7.41077 10.134 7.45044 10.5439C7.47927 10.8396 7.71391 11.0695 8.01535 11.0942L8.28933 11.1153L8.5884 11.1356L8.9068 11.1546L9.23842 11.1705C9.5185 11.182 9.80638 11.1895 10.0861 11.1895C10.3659 11.1895 10.6537 11.182 10.9338 11.1705L11.2654 11.1546L11.5838 11.1359L11.8829 11.1156L12.1569 11.0942C12.3009 11.084 12.4366 11.0231 12.54 10.9224C12.6434 10.8217 12.7078 10.6876 12.7218 10.5439C12.7615 10.134 12.7988 9.62364 12.7988 9.15503C12.7988 8.68642 12.7615 8.1761 12.7218 7.76615C12.7078 7.62247 12.6434 7.48838 12.54 7.38765C12.4366 7.28691 12.3009 7.22604 12.1569 7.21583L11.8829 7.1948L11.5838 7.17446L11.2654 7.15547L10.9338 7.13953C10.6514 7.12738 10.3688 7.12105 10.0861 7.12054ZM9.40796 8.33276C9.40793 8.29962 9.41601 8.26697 9.43148 8.23766C9.44694 8.20835 9.46934 8.18327 9.49671 8.16458C9.52408 8.1459 9.55561 8.13419 9.58854 8.13046C9.62147 8.12674 9.65481 8.13111 9.68566 8.14321L9.71313 8.15677L11.1373 8.9787C11.1656 8.99507 11.1896 9.01803 11.2072 9.04565C11.2248 9.07327 11.2354 9.10472 11.2383 9.13734C11.2411 9.16996 11.236 9.20278 11.2235 9.23302C11.2109 9.26325 11.1912 9.29 11.1661 9.311L11.1373 9.33135L9.71313 10.1536C9.68443 10.1702 9.6521 10.1796 9.61896 10.1809C9.58582 10.1821 9.55288 10.1753 9.52299 10.1609C9.49311 10.1465 9.46719 10.1251 9.44749 10.0984C9.4278 10.0717 9.41492 10.0406 9.40999 10.0078L9.40796 9.9773V8.33276Z"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                :class="`${isScrolled || vars.fixedColorBool ? 'tw-fill-[#333333]' : 'tw-fill-white'}`"
              />
            </g>
            <defs>
              <clipPath id="clip0_14_91">
                <rect width="8.13793" height="8.13793" fill="white" transform="translate(6.01758 5.08594)" />
              </clipPath>
            </defs>
          </svg>
        </nuxt-link>
        <nuxt-link
          v-if="vars.tiktokUrl"
          :to="vars.tiktokUrl"
          target="_blank"
          class="n-link tw-group tw-flex tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
        >
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="9.77627"
              cy="9.15517"
              r="8.90517"
              :stroke="`${isScrolled || vars.fixedColorBool ? '#333333' : 'white'}`"
              stroke-width="0.5"
            />
            <path
              d="M11.3353 7.05972C11.1036 6.79511 10.9758 6.45529 10.9759 6.10352H9.92816V10.3081C9.92008 10.5356 9.82402 10.7512 9.66021 10.9093C9.4964 11.0674 9.27762 11.1558 9.04995 11.1558C8.56845 11.1558 8.16834 10.7625 8.16834 10.2742C8.16834 9.69099 8.73121 9.25357 9.31104 9.43329V8.36179C8.14121 8.20581 7.11719 9.11455 7.11719 10.2742C7.11719 11.4033 8.05305 12.207 9.04656 12.207C10.1113 12.207 10.9759 11.3423 10.9759 10.2742V8.14139C11.4008 8.44651 11.9109 8.61022 12.434 8.60932V7.56156C12.434 7.56156 11.7965 7.59208 11.3353 7.05972Z"
              class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              :class="`${isScrolled || vars.fixedColorBool ? 'tw-fill-[#333333]' : 'tw-fill-white'}`"
            />
          </svg>
        </nuxt-link>
      </div>
    </div>

    <nav
      class="tw-relative tw-flex tw-w-full tw-items-center tw-px-4 tw-py-8 tw-duration-300 md:tw-px-8 lg:tw-px-16 lg:tw-py-8 xl:tw-py-12"
      :class="
        menuVisible && isScrolled ? '!tw-bg-[var(--c-primary)] !tw-shadow-none xl:!tw-bg-white xl:!tw-shadow' : ''
      "
      :style="`
      ${
        isScrolled || vars.fixedColorBool
          ? `background-color: var(--c-nav); color: var(--c-text-primary);`
          : 'background-color: transparent;'
      }
          ${menuVisible && !isScrolled ? 'background-color: var(--c-primary)' : ''}
     
      color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary) '};
    `"
    >
      <!-- Mobile Nav -->
      <div class="tw-ml-auto tw-w-[300px] tw-pl-8 xl:tw-hidden">
        <nuxt-link to="/" class="n-link tw-relative tw-block tw-w-full xl:tw-hidden" :external="true">
          <LibraryImage class="tw-w-full" :src="logo" :h-ratio="1" :w-ratio="7.2" />
        </nuxt-link>
      </div>
      <div class="tw-ml-auto tw-flex tw-items-center tw-gap-10 xl:tw-hidden">
        <button class="icon burger-menu n-link" @click="toggleMenu">
          <span :class="isScrolled || vars.fixedColorBool ? '!tw-bg-[#333333]' : '!tw-bg-white'"></span>
          <span :class="isScrolled || vars.fixedColorBool ? '!tw-bg-[#333333]' : '!tw-bg-white'"></span>
        </button>
      </div>
      <!-- Mobile Nav End -->

      <!-- Desktop Nav -->

      <div
        class="tw-absolute tw-left-1/2 tw-top-0 tw-hidden tw-h-full tw-w-full tw--translate-x-1/2 tw-items-center tw-justify-center tw-gap-12 tw-px-8 xl:tw-flex"
      >
        <div class="tw-hidden tw-w-full xl:tw-block">
          <ul class="tw-flex tw-w-full tw-items-center tw-justify-end tw-gap-8 tw-whitespace-nowrap tw-align-middle">
            <nuxt-link
              v-if="vars.buttonLinkUrl"
              :to="vars.buttonLinkUrl"
              :external="true"
              :class="{
                'n-primary tw-mr-auto': isScrolled || vars.fixedColorBool,
                'n-tertiary tw-mr-auto': !(isScrolled || vars.fixedColorBool),
              }"
            >
              {{ vars.buttonLabelText }}
            </nuxt-link>

            <li
              v-for="(menuGroup, groupIndex) in leftMenu"
              :key="`menuGroupIndex-${groupIndex}`"
              class="navigation-element tw-group tw-relative tw-duration-300"
              :class="isScrolled || vars.fixedColorBool ? '!tw-text-[#333333]' : '!tw-text-white'"
            >
              <div class="tw-flex tw-items-center tw-justify-center">
                <nuxt-link
                  :external="true"
                  :to="menuGroup.url"
                  :target="menuGroup.is_open_new_tab ? '_blank' : ''"
                  class="n-link tw-text-center tw-uppercase tw-duration-300 hover:tw-text-[var(--c-primary)]"
                >
                  {{ menuGroup.name }}
                </nuxt-link>
              </div>
              <ul
                v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
                class="sub_menu tw-pointer-events-none tw-absolute tw-mt-8 tw-max-h-0 tw-rounded-sm tw-border-[1px] tw-px-6 tw-text-left tw-opacity-0 tw-duration-700 group-hover:tw-pointer-events-auto group-hover:tw-max-h-[700px] group-hover:!tw-opacity-100"
                :style="`box-shadow: var(--c-box_shadow) ;border-radius: var(--rounded); background-color: var(--c-nav);color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}; transition-delay:.2s`"
              >
                <li
                  v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
                  :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                  class="tw-w-[220px]"
                  style="border-color: var(--c-border)"
                >
                  <nuxt-link
                    class="n-link tw-block tw-px-4 tw-text-center tw-uppercase tw-duration-300 hover:tw-ml-4 hover:!tw-text-[var(--c-primary)]"
                    :external="true"
                    :to="subMenu.url"
                    :target="subMenu.is_open_new_tab ? '_blank' : ''"
                    :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
                  >
                    {{ subMenu.name }}
                  </nuxt-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="tw-w-full tw-max-w-[250px] 2xl:tw-max-w-[320px]">
          <nuxt-link to="/" class="n-link tw-relative tw-block tw-w-full" :external="true">
            <LibraryImage class="tw-w-full" :src="logo" :h-ratio="1" :w-ratio="7.2" />
          </nuxt-link>
        </div>

        <div class="tw-hidden tw-w-full xl:tw-block">
          <ul class="tw-flex tw-w-full tw-items-center tw-justify-start tw-gap-8 tw-align-middle">
            <li
              v-for="(menuGroup, groupIndex) in rightMenu"
              :key="`menuGroupIndex-${groupIndex}`"
              class="navigation-element tw-group tw-relative tw-duration-300"
              :class="isScrolled || vars.fixedColorBool ? '!tw-text-[#333333]' : '!tw-text-white'"
            >
              <div class="tw-flex tw-items-center tw-justify-center">
                <nuxt-link
                  :external="true"
                  :to="menuGroup.url"
                  :target="menuGroup.is_open_new_tab ? '_blank' : ''"
                  class="n-link tw-text-center tw-uppercase tw-duration-300 hover:tw-text-[var(--c-primary)]"
                >
                  {{ menuGroup.name }}
                </nuxt-link>
              </div>
              <ul
                v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
                class="sub_menu tw-pointer-events-none tw-absolute tw-mt-8 tw-max-h-0 tw-rounded-sm tw-border-[1px] tw-px-6 tw-text-left tw-opacity-0 tw-duration-700 group-hover:tw-pointer-events-auto group-hover:tw-max-h-[700px] group-hover:!tw-opacity-100"
                :style="`box-shadow: var(--c-box_shadow) ;border-radius: var(--rounded); background-color: var(--c-nav);color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}; `"
              >
                <li
                  v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
                  :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                  class="tw-w-[220px]"
                  style="border-color: var(--c-border)"
                >
                  <nuxt-link
                    class="n-link tw-block tw-px-4 tw-py-2 tw-text-center tw-uppercase tw-duration-300 hover:!tw-text-[var(--c-primary)]"
                    :external="true"
                    :to="subMenu.url"
                    :target="subMenu.is_open_new_tab ? '_blank' : ''"
                    :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
                  >
                    {{ subMenu.name }}
                  </nuxt-link>
                </li>
              </ul>
            </li>
            <div class="tw-ml-auto tw-flex tw-items-center tw-gap-10">
              <button class="icon burger-menu n-link" @click="toggleMenu">
                <span :class="isScrolled || vars.fixedColorBool ? '!tw-bg-[#333333]' : '!tw-bg-white'"></span>
                <span :class="isScrolled || vars.fixedColorBool ? '!tw-bg-[#333333]' : '!tw-bg-white'"></span>
              </button>
            </div>
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <!-- Mobile Menu -->
  <div
    v-if="variants.HEADER_1 === variant"
    class="tw-fixed tw-left-0 tw-top-[-100svh] tw-z-40 tw-flex tw-h-[100svh] tw-w-full tw-flex-col tw-items-center tw-justify-start tw-gap-y-4 tw-overflow-y-auto tw-bg-black tw-p-4 !tw-pt-20 tw-duration-500 md:tw-gap-y-6 md:!tw-pt-32 xl:tw-pointer-events-none xl:tw-hidden"
    :class="!menuVisible ? '-tw-translate-y-0' : 'tw-translate-y-[100%]'"
    :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}; background-color: var(--c-primary)`"
  >
    <ul class="tw-flex tw-w-full tw-flex-col tw-gap-5 tw-pt-8">
      <li v-for="(menuGroup, groupIndex) in allMenu[0]" :key="`menuGroupIndex-${groupIndex}`" class="tw-w-full tw-px-6">
        <div
          class="tw-flex tw-w-full tw-items-center tw-justify-between tw-pb-3 tw-pt-0"
          @click="toggleSubMenu(groupIndex)"
        >
          <nuxt-link
            :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
            :target="menuGroup.is_open_new_tab ? '_blank' : ''"
            :external="true"
            class="n-link tw-uppercase tw-text-white tw-duration-300 hover:tw-text-[var(--c-secondary)]"
          >
            {{ menuGroup.name }}
          </nuxt-link>

          <div
            class="tw-flex tw-cursor-pointer tw-items-center tw-rounded tw-bg-transparent tw-p-2"
            v-if="menuGroup.has_sub_menu"
          >
            <span
              class="nc-icon-chevron-down sub-menu-arrow theme3-menu-link tw-duration-500"
              :class="{ 'tw-rotate-180': openSubMenu === groupIndex }"
            ></span>
          </div>
        </div>
        <ul
          v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
          class="tw-ml-6 tw-overflow-hidden tw-transition-all tw-duration-500"
          :class="openSubMenu === groupIndex ? 'tw-max-h-96' : 'tw-max-h-0'"
        >
          <li
            v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
            :key="`${subMenuIndex}-subMenu-${groupIndex}`"
            class="tw-pb-6 tw-pt-0"
          >
            <nuxt-link
              :to="subMenu.url"
              :target="subMenu.is_open_new_tab ? '_blank' : ''"
              class="n-link tw-text-white tw-duration-300 hover:tw-text-[var(--c-secondary)]"
              :external="true"
            >
              {{ subMenu.name }}
            </nuxt-link>
          </li>
        </ul>
      </li>
      <li class="tw-flex tw-w-full tw-flex-col tw-gap-5 tw-px-6 tw-pt-10">
        <small v-for="branch in branches" class="tw-text-white">
          <nuxt-link :to="`tel:${branch.phone_number}`" class="n-link">
            {{ branch.name }}: {{ branch.phone_number }}
          </nuxt-link>
        </small>
        <div class="tw-flex tw-w-full tw-items-center tw-justify-start tw-gap-3 tw-pt-4">
          <nuxt-link
            v-if="vars.facebookUrl"
            :to="vars.facebookUrl"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.4245" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
              <path
                d="M17.6218 17.0921H19.121L19.7208 14.6932H17.6218V13.4938C17.6218 12.8761 17.6218 12.2944 18.8212 12.2944H19.7208V10.2794C19.5252 10.2536 18.787 10.1954 18.0074 10.1954C16.3792 10.1954 15.2229 11.1891 15.2229 13.0141V14.6932H13.4238V17.0921H15.2229V22.1896H17.6218V17.0921Z"
                fill="white"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>

          <nuxt-link
            v-if="vars.instagramUrl"
            :to="vars.instagramUrl"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
            style="border-color: white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.8093" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
              <path
                d="M14.2888 10.1952H19.3264C21.2455 10.1952 22.8047 11.7544 22.8047 13.6735V18.711C22.8047 19.6335 22.4382 20.5183 21.7859 21.1706C21.1336 21.8229 20.2489 22.1893 19.3264 22.1893H14.2888C12.3698 22.1893 10.8105 20.6301 10.8105 18.711V13.6735C10.8105 12.751 11.177 11.8663 11.8293 11.214C12.4816 10.5617 13.3663 10.1952 14.2888 10.1952ZM14.1689 11.3946C13.5963 11.3946 13.0472 11.6221 12.6423 12.0269C12.2374 12.4318 12.01 12.981 12.01 13.5536V18.831C12.01 20.0244 12.9755 20.9899 14.1689 20.9899H19.4463C20.0189 20.9899 20.5681 20.7625 20.9729 20.3576C21.3778 19.9527 21.6053 19.4036 21.6053 18.831V13.5536C21.6053 12.3601 20.6397 11.3946 19.4463 11.3946H14.1689ZM19.9561 12.2942C20.1549 12.2942 20.3456 12.3731 20.4862 12.5137C20.6267 12.6543 20.7057 12.845 20.7057 13.0438C20.7057 13.2426 20.6267 13.4333 20.4862 13.5739C20.3456 13.7145 20.1549 13.7934 19.9561 13.7934C19.7573 13.7934 19.5666 13.7145 19.426 13.5739C19.2854 13.4333 19.2064 13.2426 19.2064 13.0438C19.2064 12.845 19.2854 12.6543 19.426 12.5137C19.5666 12.3731 19.7573 12.2942 19.9561 12.2942ZM16.8076 13.1937C17.6029 13.1937 18.3656 13.5096 18.9279 14.072C19.4902 14.6343 19.8062 15.397 19.8062 16.1923C19.8062 16.9875 19.4902 17.7502 18.9279 18.3125C18.3656 18.8749 17.6029 19.1908 16.8076 19.1908C16.0124 19.1908 15.2497 18.8749 14.6873 18.3125C14.125 17.7502 13.8091 16.9875 13.8091 16.1923C13.8091 15.397 14.125 14.6343 14.6873 14.072C15.2497 13.5096 16.0124 13.1937 16.8076 13.1937ZM16.8076 14.3931C16.3305 14.3931 15.8728 14.5827 15.5354 14.9201C15.198 15.2575 15.0085 15.7151 15.0085 16.1923C15.0085 16.6694 15.198 17.127 15.5354 17.4644C15.8728 17.8018 16.3305 17.9914 16.8076 17.9914C17.2848 17.9914 17.7424 17.8018 18.0798 17.4644C18.4172 17.127 18.6067 16.6694 18.6067 16.1923C18.6067 15.7151 18.4172 15.2575 18.0798 14.9201C17.7424 14.5827 17.2848 14.3931 16.8076 14.3931Z"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>
          <nuxt-link
            v-if="vars.youtubeUrl"
            :to="vars.youtubeUrl"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
            style="border-color: white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.5769" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
              <path
                d="M16.5752 11.3946C17.0879 11.3946 17.6139 11.4078 18.1236 11.4294L18.7257 11.4582L19.3021 11.4923L19.8418 11.5289L20.3348 11.5673C20.8697 11.6083 21.3731 11.8365 21.7564 12.212C22.1396 12.5875 22.3782 13.0861 22.4301 13.6201L22.4541 13.875L22.4991 14.4207C22.5411 14.9862 22.5723 15.6027 22.5723 16.1922C22.5723 16.7818 22.5411 17.3983 22.4991 17.9638L22.4541 18.5095C22.4463 18.5971 22.4385 18.6816 22.4301 18.7644C22.3782 19.2985 22.1395 19.7972 21.7562 20.1727C21.3728 20.5482 20.8692 20.7764 20.3342 20.8172L19.8424 20.855L19.3027 20.8922L18.7257 20.9263L18.1236 20.9551C17.6078 20.9775 17.0915 20.9891 16.5752 20.9899C16.0589 20.9891 15.5426 20.9775 15.0268 20.9551L14.4246 20.9263L13.8483 20.8922L13.3086 20.855L12.8156 20.8172C12.2807 20.7762 11.7773 20.548 11.394 20.1725C11.0107 19.797 10.7722 19.2984 10.7203 18.7644L10.6963 18.5095L10.6513 17.9638C10.6054 17.3744 10.581 16.7835 10.5781 16.1922C10.5781 15.6027 10.6093 14.9862 10.6513 14.4207L10.6963 13.875C10.7041 13.7874 10.7119 13.7029 10.7203 13.6201C10.7722 13.0862 11.0106 12.5877 11.3938 12.2122C11.7769 11.8367 12.2802 11.6084 12.815 11.5673L13.3074 11.5289L13.8471 11.4923L14.424 11.4582L15.0262 11.4294C15.5422 11.407 16.0587 11.3954 16.5752 11.3946ZM16.5752 12.594C16.0804 12.594 15.5713 12.6072 15.0759 12.6276L14.4894 12.6558L13.9263 12.6888L13.3973 12.7247L12.9128 12.7625C12.6581 12.7806 12.4181 12.8883 12.2352 13.0664C12.0523 13.2446 11.9384 13.4817 11.9137 13.7358C11.8435 14.4609 11.7775 15.3635 11.7775 16.1922C11.7775 17.021 11.8435 17.9236 11.9137 18.6487C11.9646 19.1716 12.3796 19.5782 12.9128 19.622L13.3973 19.6592L13.9263 19.6951L14.4894 19.7287L15.0759 19.7569C15.5713 19.7773 16.0804 19.7905 16.5752 19.7905C17.07 19.7905 17.5791 19.7773 18.0745 19.7569L18.661 19.7287L19.2241 19.6957L19.753 19.6598L20.2376 19.622C20.4923 19.6039 20.7323 19.4962 20.9152 19.3181C21.0981 19.1399 21.212 18.9028 21.2367 18.6487C21.3069 17.9236 21.3729 17.021 21.3729 16.1922C21.3729 15.3635 21.3069 14.4609 21.2367 13.7358C21.212 13.4817 21.0981 13.2446 20.9152 13.0664C20.7323 12.8883 20.4923 12.7806 20.2376 12.7625L19.753 12.7253L19.2241 12.6894L18.661 12.6558L18.0745 12.6276C17.575 12.6061 17.0751 12.5949 16.5752 12.594ZM15.3758 14.738C15.3757 14.6793 15.39 14.6216 15.4174 14.5698C15.4447 14.5179 15.4843 14.4736 15.5328 14.4405C15.5812 14.4075 15.6369 14.3868 15.6952 14.3802C15.7534 14.3736 15.8124 14.3813 15.8669 14.4027L15.9155 14.4267L18.4343 15.8804C18.4844 15.9093 18.5269 15.95 18.558 15.9988C18.5891 16.0477 18.6079 16.1033 18.6129 16.161C18.6179 16.2187 18.6089 16.2767 18.5867 16.3302C18.5645 16.3837 18.5297 16.431 18.4853 16.4681L18.4343 16.5041L15.9155 17.9584C15.8648 17.9878 15.8076 18.0043 15.749 18.0066C15.6904 18.0088 15.6321 17.9967 15.5792 17.9713C15.5264 17.9458 15.4805 17.9079 15.4457 17.8607C15.4109 17.8135 15.3881 17.7585 15.3794 17.7005L15.3758 17.6465V14.738Z"
                fill="white"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>
          <nuxt-link
            v-if="vars.tiktokUrl"
            :to="vars.tiktokUrl"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.1921" cy="16.1921" r="15.9421" stroke="#fff" stroke-width="0.5" />
              <path
                d="M18.9506 12.4863C18.5406 12.0183 18.3147 11.4173 18.3149 10.7952H16.4618V18.2315C16.4475 18.634 16.2776 19.0151 15.9879 19.2948C15.6982 19.5744 15.3112 19.7307 14.9086 19.7308C14.057 19.7308 13.3493 19.0351 13.3493 18.1716C13.3493 17.1401 14.3448 16.3664 15.3703 16.6843V14.7892C13.3014 14.5134 11.4902 16.1206 11.4902 18.1716C11.4902 20.1686 13.1454 21.5899 14.9026 21.5899C16.7856 21.5899 18.3149 20.0606 18.3149 18.1716V14.3994C19.0663 14.9391 19.9685 15.2286 20.8936 15.227V13.3739C20.8936 13.3739 19.7662 13.4279 18.9506 12.4863Z"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>
        </div>
      </li>
      <li class="tw-w-full tw-px-6 tw-pt-6" v-if="vars.buttonLabelText">
        <nuxt-link :to="vars.buttonLinkUrl" :class="`n-primary`" :external="true">{{ vars.buttonLabelText }}</nuxt-link>
      </li>
    </ul>
  </div>

  <!-- Desktop Menu -->
  <div
    v-if="variants.HEADER_1 === variant"
    class="tw-pointer-events-none tw-fixed tw-right-0 tw-top-0 tw-z-[9999] tw-hidden tw-h-full tw-w-[610px] tw-overflow-y-auto tw-duration-500 xl:tw-pointer-events-auto xl:tw-block"
    :class="menuVisible ? '-tw-translate-x-0' : 'tw-translate-x-[101%]'"
    :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}; background-color: var(--c-primary)`"
  >
    <div class="tw-flex tw-items-center tw-justify-end tw-px-6 tw-pt-10">
      <button class="icon active burger-menu n-link" @click="toggleMenu">
        <span class="!tw-bg-white"></span>
        <span class="!tw-bg-white"></span>
      </button>
    </div>

    <ul class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-pt-8">
      <div class="tw-w-[300px] tw-pb-8">
        <nuxt-link to="/" class="n-link tw-relative tw-block tw-w-full" :external="true">
          <LibraryImage class="tw-w-full" :src="company.logo" :h-ratio="1" :w-ratio="7.2" />
        </nuxt-link>
      </div>
      <li v-for="(menuGroup, groupIndex) in remainingMenu" :key="`menuGroupIndex-${groupIndex}`">
        <div
          class="tw-flex tw-w-full tw-items-center tw-justify-between tw-pb-2 tw-pt-0"
          @click="toggleSubMenu(groupIndex)"
        >
          <nuxt-link
            :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
            :target="menuGroup.is_open_new_tab ? '_blank' : ''"
            :external="true"
            class="n-link tw-uppercase tw-text-white tw-duration-300 hover:tw-text-[var(--c-secondary)]"
          >
            {{ menuGroup.name }}
          </nuxt-link>
          <div
            class="tw-flex tw-cursor-pointer tw-items-center tw-rounded tw-bg-transparent tw-p-2"
            v-if="menuGroup.has_sub_menu"
          >
            <span
              class="nc-icon-chevron-down sub-menu-arrow theme3-menu-link tw-duration-500"
              :class="{ 'tw-rotate-180': openSubMenu === groupIndex }"
            ></span>
          </div>
        </div>
        <ul
          v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
          class="tw-ml-6 tw-overflow-hidden tw-transition-all tw-duration-500"
          :class="openSubMenu === groupIndex ? 'tw-max-h-96' : 'tw-max-h-0'"
        >
          <li
            v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
            :key="`${subMenuIndex}-subMenu-${groupIndex}`"
            class="tw-pb-6 tw-pt-0"
          >
            <nuxt-link
              :to="subMenu.url"
              :target="subMenu.is_open_new_tab ? '_blank' : ''"
              class="n-link hover:tw-text-[var(--c-primary)]"
              :external="true"
              :class="`tw-duration-300 hover:tw-text-[var(--c-${vars.hoverTextColor})]`"
            >
              {{ subMenu.name }}
            </nuxt-link>
          </li>
        </ul>
      </li>
      <div
        class="tw-flex tw-max-w-[390px] tw-flex-col tw-items-center tw-justify-center tw-gap-5 tw-pt-12 tw-text-center tw-text-white"
      >
        <h3>{{ vars.titleText }}</h3>
        <p>{{ vars.descriptionText }}</p>
      </div>
      <div
        class="tw-flex tw-max-w-[390px] tw-flex-col tw-items-center tw-justify-center tw-gap-5 tw-pt-12 tw-text-center tw-text-white"
      >
        <h3>FOLLOW US</h3>
        <div class="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-2">
          <nuxt-link
            v-if="vars.facebookUrl"
            :to="vars.facebookUrl"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.4245" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
              <path
                d="M17.6218 17.0921H19.121L19.7208 14.6932H17.6218V13.4938C17.6218 12.8761 17.6218 12.2944 18.8212 12.2944H19.7208V10.2794C19.5252 10.2536 18.787 10.1954 18.0074 10.1954C16.3792 10.1954 15.2229 11.1891 15.2229 13.0141V14.6932H13.4238V17.0921H15.2229V22.1896H17.6218V17.0921Z"
                fill="white"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>

          <nuxt-link
            v-if="vars.instagramUrl"
            :to="vars.instagramUrl"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
            style="border-color: white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.8093" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
              <path
                d="M14.2888 10.1952H19.3264C21.2455 10.1952 22.8047 11.7544 22.8047 13.6735V18.711C22.8047 19.6335 22.4382 20.5183 21.7859 21.1706C21.1336 21.8229 20.2489 22.1893 19.3264 22.1893H14.2888C12.3698 22.1893 10.8105 20.6301 10.8105 18.711V13.6735C10.8105 12.751 11.177 11.8663 11.8293 11.214C12.4816 10.5617 13.3663 10.1952 14.2888 10.1952ZM14.1689 11.3946C13.5963 11.3946 13.0472 11.6221 12.6423 12.0269C12.2374 12.4318 12.01 12.981 12.01 13.5536V18.831C12.01 20.0244 12.9755 20.9899 14.1689 20.9899H19.4463C20.0189 20.9899 20.5681 20.7625 20.9729 20.3576C21.3778 19.9527 21.6053 19.4036 21.6053 18.831V13.5536C21.6053 12.3601 20.6397 11.3946 19.4463 11.3946H14.1689ZM19.9561 12.2942C20.1549 12.2942 20.3456 12.3731 20.4862 12.5137C20.6267 12.6543 20.7057 12.845 20.7057 13.0438C20.7057 13.2426 20.6267 13.4333 20.4862 13.5739C20.3456 13.7145 20.1549 13.7934 19.9561 13.7934C19.7573 13.7934 19.5666 13.7145 19.426 13.5739C19.2854 13.4333 19.2064 13.2426 19.2064 13.0438C19.2064 12.845 19.2854 12.6543 19.426 12.5137C19.5666 12.3731 19.7573 12.2942 19.9561 12.2942ZM16.8076 13.1937C17.6029 13.1937 18.3656 13.5096 18.9279 14.072C19.4902 14.6343 19.8062 15.397 19.8062 16.1923C19.8062 16.9875 19.4902 17.7502 18.9279 18.3125C18.3656 18.8749 17.6029 19.1908 16.8076 19.1908C16.0124 19.1908 15.2497 18.8749 14.6873 18.3125C14.125 17.7502 13.8091 16.9875 13.8091 16.1923C13.8091 15.397 14.125 14.6343 14.6873 14.072C15.2497 13.5096 16.0124 13.1937 16.8076 13.1937ZM16.8076 14.3931C16.3305 14.3931 15.8728 14.5827 15.5354 14.9201C15.198 15.2575 15.0085 15.7151 15.0085 16.1923C15.0085 16.6694 15.198 17.127 15.5354 17.4644C15.8728 17.8018 16.3305 17.9914 16.8076 17.9914C17.2848 17.9914 17.7424 17.8018 18.0798 17.4644C18.4172 17.127 18.6067 16.6694 18.6067 16.1923C18.6067 15.7151 18.4172 15.2575 18.0798 14.9201C17.7424 14.5827 17.2848 14.3931 16.8076 14.3931Z"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>
          <nuxt-link
            v-if="vars.youtubeUrl"
            :to="vars.youtubeUrl"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
            style="border-color: white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.5769" cy="16.1921" r="15.9421" stroke="white" stroke-width="0.5" />
              <path
                d="M16.5752 11.3946C17.0879 11.3946 17.6139 11.4078 18.1236 11.4294L18.7257 11.4582L19.3021 11.4923L19.8418 11.5289L20.3348 11.5673C20.8697 11.6083 21.3731 11.8365 21.7564 12.212C22.1396 12.5875 22.3782 13.0861 22.4301 13.6201L22.4541 13.875L22.4991 14.4207C22.5411 14.9862 22.5723 15.6027 22.5723 16.1922C22.5723 16.7818 22.5411 17.3983 22.4991 17.9638L22.4541 18.5095C22.4463 18.5971 22.4385 18.6816 22.4301 18.7644C22.3782 19.2985 22.1395 19.7972 21.7562 20.1727C21.3728 20.5482 20.8692 20.7764 20.3342 20.8172L19.8424 20.855L19.3027 20.8922L18.7257 20.9263L18.1236 20.9551C17.6078 20.9775 17.0915 20.9891 16.5752 20.9899C16.0589 20.9891 15.5426 20.9775 15.0268 20.9551L14.4246 20.9263L13.8483 20.8922L13.3086 20.855L12.8156 20.8172C12.2807 20.7762 11.7773 20.548 11.394 20.1725C11.0107 19.797 10.7722 19.2984 10.7203 18.7644L10.6963 18.5095L10.6513 17.9638C10.6054 17.3744 10.581 16.7835 10.5781 16.1922C10.5781 15.6027 10.6093 14.9862 10.6513 14.4207L10.6963 13.875C10.7041 13.7874 10.7119 13.7029 10.7203 13.6201C10.7722 13.0862 11.0106 12.5877 11.3938 12.2122C11.7769 11.8367 12.2802 11.6084 12.815 11.5673L13.3074 11.5289L13.8471 11.4923L14.424 11.4582L15.0262 11.4294C15.5422 11.407 16.0587 11.3954 16.5752 11.3946ZM16.5752 12.594C16.0804 12.594 15.5713 12.6072 15.0759 12.6276L14.4894 12.6558L13.9263 12.6888L13.3973 12.7247L12.9128 12.7625C12.6581 12.7806 12.4181 12.8883 12.2352 13.0664C12.0523 13.2446 11.9384 13.4817 11.9137 13.7358C11.8435 14.4609 11.7775 15.3635 11.7775 16.1922C11.7775 17.021 11.8435 17.9236 11.9137 18.6487C11.9646 19.1716 12.3796 19.5782 12.9128 19.622L13.3973 19.6592L13.9263 19.6951L14.4894 19.7287L15.0759 19.7569C15.5713 19.7773 16.0804 19.7905 16.5752 19.7905C17.07 19.7905 17.5791 19.7773 18.0745 19.7569L18.661 19.7287L19.2241 19.6957L19.753 19.6598L20.2376 19.622C20.4923 19.6039 20.7323 19.4962 20.9152 19.3181C21.0981 19.1399 21.212 18.9028 21.2367 18.6487C21.3069 17.9236 21.3729 17.021 21.3729 16.1922C21.3729 15.3635 21.3069 14.4609 21.2367 13.7358C21.212 13.4817 21.0981 13.2446 20.9152 13.0664C20.7323 12.8883 20.4923 12.7806 20.2376 12.7625L19.753 12.7253L19.2241 12.6894L18.661 12.6558L18.0745 12.6276C17.575 12.6061 17.0751 12.5949 16.5752 12.594ZM15.3758 14.738C15.3757 14.6793 15.39 14.6216 15.4174 14.5698C15.4447 14.5179 15.4843 14.4736 15.5328 14.4405C15.5812 14.4075 15.6369 14.3868 15.6952 14.3802C15.7534 14.3736 15.8124 14.3813 15.8669 14.4027L15.9155 14.4267L18.4343 15.8804C18.4844 15.9093 18.5269 15.95 18.558 15.9988C18.5891 16.0477 18.6079 16.1033 18.6129 16.161C18.6179 16.2187 18.6089 16.2767 18.5867 16.3302C18.5645 16.3837 18.5297 16.431 18.4853 16.4681L18.4343 16.5041L15.9155 17.9584C15.8648 17.9878 15.8076 18.0043 15.749 18.0066C15.6904 18.0088 15.6321 17.9967 15.5792 17.9713C15.5264 17.9458 15.4805 17.9079 15.4457 17.8607C15.4109 17.8135 15.3881 17.7585 15.3794 17.7005L15.3758 17.6465V14.738Z"
                fill="white"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>
          <nuxt-link
            v-if="vars.tiktokUrl"
            :to="vars.tiktokUrl"
            target="_blank"
            class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-transparent tw-transition-all tw-duration-300 hover:tw-bg-white"
          >
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.1921" cy="16.1921" r="15.9421" stroke="#fff" stroke-width="0.5" />
              <path
                d="M18.9506 12.4863C18.5406 12.0183 18.3147 11.4173 18.3149 10.7952H16.4618V18.2315C16.4475 18.634 16.2776 19.0151 15.9879 19.2948C15.6982 19.5744 15.3112 19.7307 14.9086 19.7308C14.057 19.7308 13.3493 19.0351 13.3493 18.1716C13.3493 17.1401 14.3448 16.3664 15.3703 16.6843V14.7892C13.3014 14.5134 11.4902 16.1206 11.4902 18.1716C11.4902 20.1686 13.1454 21.5899 14.9026 21.5899C16.7856 21.5899 18.3149 20.0606 18.3149 18.1716V14.3994C19.0663 14.9391 19.9685 15.2286 20.8936 15.227V13.3739C20.8936 13.3739 19.7662 13.4279 18.9506 12.4863Z"
                class="tw-fill-white tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </nuxt-link>
        </div>
      </div>
    </ul>

    <nuxt-link></nuxt-link>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { MenuTypes, ViewTypes } from '~/constants/ui.constants';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';
import { useCoreStore } from '~/units/core/store';

type Menu = {};

export default defineNuxtComponent({
  name: 'Theme8BaseHeaderOne',

  mixins: [ComponentMixin],

  props: {
    component: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      ViewTypes,
      menuVisible: false,
      isScrolled: false,
      openSubMenu: null,
      variants: {
        HEADER_1: 'HEADER_1',
        HEADER_2: 'HEADER_2',
      },
      isActive: false,
      scrollThreshold: 350,
      isLightMode: false,
      isMenuOpen: false,
      scrollPosition: 0,
    };
  },

  computed: {
    ...mapState(useWebsiteStore, ['headerMenuItems']),
    ...mapState(useCoreStore, ['isAnythingOnTopVisible']),

    headerMenu() {
      return this.headerMenuItems as Menu[];
    },

    branches() {
      return this.groupedVariables.branches;
    },

    routeUrl() {
      const route = useRoute();
      return route.path;
    },

    allMenu() {
      const period = 9;
      const columnsCount = Math.ceil(this.columnOneMenu.length / period);
      const groups = [];

      for (let i = 0; i < columnsCount; i++) {
        groups[i] = [];
        for (let p = 0; p < period; p++) {
          const index = period * i + p;
          if (this.columnOneMenu[index]) {
            groups[i].push(this.columnOneMenu[index]);
          }
        }
      }

      return groups;
    },

    columnOneMenu() {
      const content = this.component.variables['column_one_content-text'];
      if (content === MenuTypes.HEADER_MENU) {
        return this.headerMenu;
      }
      return [];
    },

    leftMenu() {
      return this.allMenu[0].slice(0, 2);
    },
    rightMenu() {
      return this.allMenu[0].slice(2, 5);
    },
    remainingMenu() {
      return this.allMenu[0].slice(5);
    },

    logo() {
      if (this.menuVisible && this.isMobileDevice) {
        return this.company.logo;
      } else if (this.isScrolled) {
        return this.company.light_logo;
      } else if (!this.vars.fixedColorBool && !this.isScrolled) {
        return this.company.logo;
      }
      return this.company.light_logo;
    },

    navTextColor() {
      if (this.isScrolled) {
        return 'primary';
      }
      return this.vars.navTextColor || 'secondary';
    },
  },

  methods: {
    toggleSubMenu(index) {
      this.openSubMenu = this.openSubMenu === index ? null : index;
    },

    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      if (this.menuVisible) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
      this.toggleActiveClass();
    },

    toggleBurgerMenu() {
      if (!this.menuVisible) {
        const navItems = document.querySelectorAll('.nav-item');
        navItems.forEach((item, index) => {
          setTimeout(() => {
            item.classList.add('nav-item-visible');
          }, index * 150);
        });
      } else {
        const navItems = document.querySelectorAll('.nav-item');
        navItems.forEach((item, index) => {
          setTimeout(
            () => {
              item.classList.remove('nav-item-visible');
            },
            (navItems.length - index) * 150,
          );
        });
        setTimeout(() => {
          this.menuVisible = false;
          document.body.classList.remove('burger-menu-visible');
          document.body.classList.remove('no-scroll');
        }, navItems.length * 150);
        return;
      }

      this.menuVisible = !this.menuVisible;
      document.body.classList.toggle('burger-menu-visible', this.menuVisible);
      if (this.menuVisible) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > this.scrollThreshold;
    },
    toggleTheme() {
      this.isLightMode = !this.isLightMode;
      const htmlElement = document.documentElement;
      htmlElement.classList.toggle('light-mode');

      // Optionally, save the theme preference in localStorage
      if (htmlElement.classList.contains('light-mode')) {
        localStorage.setItem('theme', 'light');
      } else {
        localStorage.setItem('theme', 'dark');
      }
    },

    toggleActiveClass() {
      const burgerMenu = document.querySelector('.burger-menu');
      burgerMenu.classList.toggle('active');
      burgerMenu.querySelectorAll('span').forEach((span) => {
        span.classList.toggle('active');
      });
    },

    closeBurgerMenu() {
      this.menuVisible = false;
      document.body.classList.remove('burger-menu-visible');
    },
  },

  mounted() {
    console.log(this.vars.fixedColorBool);
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();

    if (this.menuVisible) {
      document.body.classList.add('no-scroll');
    }

    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'light') {
      this.isLightMode = true;
      document.documentElement.classList.add('light-mode');
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    document.body.classList.remove('no-scroll');
  },
});
</script>
<style>
.no-scroll {
  overflow: hidden;
  width: 100%;
}
</style>
<style scoped>
::-webkit-scrollbar {
  display: none;
}

.nav-item {
  transform: translateY(-20px);
  opacity: 0;
  transition: all 0.4s ease-in-out;
}

.nav-item-visible {
  transform: translateY(0);
  opacity: 1;
}

.nav-item-closing {
  animation: fadeOutToBottom 0.4s forwards;
}

@keyframes fadeOutToBottom {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(20px);
    opacity: 0;
  }
}

.nav-menu {
  opacity: 0;
  pointer-events: none;
  transition: all 0.5s ease-in-out;
}

.burger-menu-visible .nav-menu {
  opacity: 1;
  pointer-events: initial;
}

.burger-menu-visible .navbar {
  background-color: transparent !important;
}

button.icon {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: transparent;
  cursor: pointer;
  align-items: center;
  width: 40px;
  height: 40px;
  justify-content: center;
  border: 1.3px solid inherit;
  border-radius: 8px;
}

button.icon > span {
  height: 2px;
  width: 32px;
  background: inherit;
  border-radius: 30px;
  transition: all 0.3s linear;
}

/* Hover effects */
button.icon:hover > span {
  width: 32px;
}
button.icon.active:hover > span {
  width: 32px;
  margin-left: 0;
}

button.icon:hover > span:nth-child(2) {
  width: 32px;
  margin-left: 0;
}

button.icon.active {
  border-color: #fff !important;
}

button.icon.active > span {
  transform: rotate(45deg);
  margin-bottom: -4px;
}

button.icon.active > span.active {
  background: #fff !important;
}

button.icon.active > span:nth-child(2) {
  width: 32px;
  margin-left: 0;
  margin-top: -5px;
  transform: rotate(-45deg);
  margin-bottom: 0;
}

button.icon span {
  transition: 0.3s ease-in-out;
}

.scrolled {
  animation: fadeIn 0.8s ease-in-out;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    top: -50px;
  }
  to {
    opacity: 1;
    top: 0;
  }
}
</style>
